module.exports = __webpack_public_path__ + "img/logo.6e5ef57f.png";


//////////////////
// WEBPACK FOOTER
// ./_source/cqsx/pages/cqsx/cmps/home/img/logo.png
// module id = 225
// module chunks = 0